<template>
    <div class="wpb__container page_content">
        <!--<h1>{{filterProducts}}</h1>-->
        <aside class="filters">

            <div class="mobile-filter__open filter__btn">
                <button @click="toggleScroll">
                    <span v-text="filterText"></span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14.3" ><path d="M14 7.2L6.9 0l-.6.6 6 6.1H0v.9h12.3l-6 6.1.6.6z"/></svg>
                </button>
            </div>

            <!-- <div class="mobile-filter__open filter__btn">

                <a href="#/" @click="filterVisible = !filterVisible">
                    <span v-text="filterText"></span>
                    <span class="icon"></span>
                </a>

            </div> -->
            <div class="filter-section" :class="{visible: filterVisible}">

                <!-- <bhf-category-switcher :special-filter-slug="specialFilterSlug" :product-categories="productCategories"></bhf-category-switcher> -->

                <!-- <p class="filter--pgh">{{ productCategory.content }}</p> -->

                <bhf-select ref="select" :productCategoriesData="this.productCategory"></bhf-select>

                <a href="#" @click="filterVisible = false" class="mobile-filter__close filter-btn">{{ applyFilterText }}</a>

            </div><!-- /.filter-section -->
        </aside><!-- /.aside -->

        <bhf-listing ref="listing" :special-filter-slug="specialFilterSlug" :products="filteredProducts" :isFetching="isFetching"></bhf-listing>

    </div>
</template>
<script>
    import 'jquery-match-height';
    import BhfListing from './bhf-filter-listing.vue'
    import BhfSelect from './bhf-filter-select.vue'
    import BhfCategorySwitcher from './bhf-category-switcher.vue'
    import axios from 'axios';
    import helpers from '../../helpers';
    import throttle from 'lodash/throttle';

    $(window).on('load', function () {
        matchHeight();
    });

    $(window).on('resize', function () {
        throttle(matchHeight, 800);
    });

    function matchHeight(){
        $('.post__content-inner h2').matchHeight({byRow: true});
        $('.product-content').matchHeight({byRow: true});
        $('.characteristics').matchHeight({byRow: true});
    }

    export default{
        components: {
            BhfCategorySwitcher,
            'bhf-listing': BhfListing,
            'bhf-select': BhfSelect,
            'bhf-category-switcher': BhfCategorySwitcher
        },
        props: {
            'title': {required: true},
            // 'filterText': {required: true},
            'productData': {required: true},
            'specialFilterSlug': {required: true},
            'productCategories': {required: true},
            'productCategoryData': {required: true},
        },
        data: function(){
            return {
                helpers: helpers,
                loaded: false,
                filterVisible: false,
                isFetching: false,
                productCategory: {},
                products: this.productData
            }
        },
        mounted: function(){
            this.products = this.productData;
            this.productCategory = this.productCategoryData;
            this.loaded = true;
            this.newsletterButton = document.getElementsByClassName('newsletter-action')[0];
        },
        watch: {
            '$route.params.slug': function() {
                const slug = this.$route.params.slug;
                if(slug) {
                    this.fetchNewProducts(slug)
                }
            },
            'filteredProducts': function(){
                this.$refs.listing.reInit();
            }
        },
        methods: {
            toggleScroll: function(){
                this.filterVisible = !this.filterVisible
                if(this.filterVisible) {
                    document.body.classList.add('overflow-hidden')
                }else{
                    document.body.classList.remove('overflow-hidden')
                }
                (this.filterVisible) ? this.newsletterButton.style.display = 'none' : this.newsletterButton.style.display = 'block';
            },
            fetchNewProducts: function(slug){
                let _this = this;
                _this.isFetching = true;

                axios.get('/api/v1/' + this.specialFilterSlug + '/' + slug + '?locale=' + helpers.getLocale())
                    .then(function (response) {

                        // Reset the filters
                        _this.$refs.select.resetFilter();

                        // Set new listing state
                        _this.products = response.data.products;
                        _this.productCategory = response.data.activeProductCategory;

                        //jquery plugin to match the heights...
                        setTimeout(function(){
                            matchHeight();
                        }, 300);


                        _this.isFetching = false;
                    })
                    .catch(function (error) {
                        //console.error(error);
                        _this.isFetching = false
                    })


            },

        },
        computed: {
            filteredProducts: function(){
                if(!this.loaded || !this.hasFilter) return this.products;

                let filterValues = this.$refs['select'].filtered.filter(item => item);

                return this.products.filter(function(product, index){
                        for (const filter of filterValues) {
                            if(! product.filterOptions.map(option => option.id).includes(filter)) {
                                return false
                            }
                        };
                        return true;
                });
            },
            hasFilter: function() {
                return this.$refs.select.filtered.some(el => el !== 0);
            },
            filterText(){
                if(helpers.getLocale() === 'nl') {
                    return 'FILTEREN';
                }
                return 'FILTER';
            },

            applyFilterText(){
                if(helpers.getLocale() === 'nl') {
                    return 'FILTER TOEPASSEN';
                }
                return 'APPLY FILTER';
            }
        }
    }
</script>
<style lang="scss" scoped>

    .filter-section{
        margin-bottom: 25px;
    }

    .filter__btn{
        border: none;
        max-width: 288px;
        margin-left: -10px;
        a{
            padding: 0 10px;
            border: 2px solid #000000;
            background: none;
            font-size: 14px;
        }
    }
    .filter--pgh{
        margin-top: 15px;
    }



    @media screen and(max-width: 374px){
        .filters h1{
            margin-left: -15px;
        }
        .filter__btn{
            margin-left: -24px;
            margin-right: -20px;
            a{
                font-size: 13px;
            }
        }
    }

    @media screen and(min-width: 375px) and (max-width: 413px) {
        .filter__btn {
            margin-left: -24px;
        }
        .filters h1 {
            margin-left: -13px;
        }
    }

    @media screen and (max-width: 767px){
        .filter__btn {
            padding: 0 0 0 10px;
        }
    }

    .icon{
        background: url(/images/arrow.svg?0eb75b8…) no-repeat 100%;
        width: 22px;
        height: 33px;
        display: inline-block;
        float: right;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/site/components/temporary-bhf-filter/bhf-filter-root.vue